(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["safnav-mobile"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const root = event.target.closest('[data-safnav-mobile]');
    if (!root) return;
    const open = event.target.closest('[data-safnav-open]');
    const back = event.target.closest('[data-safnav-back]');
    if (open) {
      const panel = [...root.querySelectorAll('[data-safnav-panel]')].find((node) => node.dataset.safnavPanel === open.dataset.safnavOpen);
      if (!panel) return;
      root.querySelectorAll('[data-safnav-panel]').forEach((node) => { node.hidden = true; });
      panel.hidden = false;
      root.querySelector('[data-safnav-home]').hidden = true;
      panel.querySelector('[data-safnav-back]')?.focus();
    }
    if (back) {
      const panel = back.closest('[data-safnav-panel]');
      panel.hidden = true;
      root.querySelector('[data-safnav-home]').hidden = false;
      root.querySelector('[data-safnav-open="' + panel.dataset.safnavPanel + '"]')?.focus();
    }
  });
  document.addEventListener('toggle', (event) => {
    if (event.target.id !== 'Details-menu-drawer-container' || event.target.open) return;
    const root = event.target.querySelector('[data-safnav-mobile]');
    if (!root) return;
    root.querySelectorAll('[data-safnav-panel]').forEach((node) => { node.hidden = true; });
    root.querySelector('[data-safnav-home]').hidden = false;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-button-cart"] && !Shopify.designMode) return;
  try {
    (function() {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();

      this.handleAtcVisibility = this.handleAtcVisibility.bind(this);
      this.onActivate = this.onActivate.bind(this);

      this.atcObserver = null;

      this.btnLabel = this.querySelector('[data-satc-btn-label]');
      this.priceEl = this.querySelector('[data-satc-price]');
    }

    connectedCallback() {
      this.refreshExternalRefs();
      this.mountListeners();

      // evita animazioni iniziali
      this.classList.remove('satc--showing', 'satc--hiding', 'satc--hidden');
      this.setupAtcObserver();

      setTimeout(() => this.refreshExternalRefs(), 300);
    }

    refreshExternalRefs() {
      this.mainForm = document.querySelector('form[action^="/cart/add"]');
      this.mainVariantInput = this.mainForm?.querySelector('[name="id"]');
      this.mainQtyInput = this.mainForm?.querySelector('[name="quantity"]');

      this.themeAtcComponent = document.querySelector('add-to-cart-component');
      this.themeAtcButton = this.themeAtcComponent?.querySelector('button[name="add"]');
    }

    mountListeners() {
      // click su tutto lo sticky
      this.addEventListener('click', this.onActivate);

      // Enter / Space da tastiera
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.onActivate(e);
        }
      });
    }

    onActivate(e) {
      if (this.getAttribute('aria-disabled') === 'true') return;

      e.preventDefault();

      this.refreshExternalRefs();

      const id = this.getCurrentVariantId();
      const quantity = 1;

      if (!id) {
        console.warn('[SATC] Missing variant id → abort');
        return;
      }

      if (this.mainVariantInput) this.mainVariantInput.value = id;
      if (this.mainQtyInput) this.mainQtyInput.value = quantity;

      // ✅ Fly-to-cart NATIVO TEMA (parte dallo sticky)
      this.animateThemeFlyToCart();

      // preserva logica tema
      if (this.themeAtcButton) {
        this.themeAtcButton.click();
        return;
      }

      if (this.mainForm) {
        this.mainForm.requestSubmit();
        return;
      }

      this.addViaAjax(id, quantity);
    }

    getCurrentVariantId() {
      const idInput = this.mainForm?.querySelector('[name="id"]');
      if (idInput?.value) return idInput.value;

      return document.querySelector('[name="id"]')?.value;
    }

    async addViaAjax(id, quantity) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(id), quantity })
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data?.description || 'ATC failed');

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));
      } catch (err) {
        console.error('[SATC ajax error]', err);
      }
    }

    /* =========================
       Fly-to-cart NATIVO tema
       ========================= */
    animateThemeFlyToCart() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const cartIcon = document.querySelector('.header-actions__cart-icon');
      if (!cartIcon) return;

      // stessa immagine che usa il tema
      const image =
        this.themeAtcComponent?.dataset?.productVariantMedia ||
        document.querySelector('[data-product-variant-media]')?.dataset?.productVariantMedia ||
        document.querySelector('.product__media img, img[data-product-featured-image], img')?.src;

      if (!image) return;

      const flyEl = document.createElement('fly-to-cart');
      flyEl.style.setProperty('background-image', `url(${image})`);

      // ✅ partenza dallo sticky
      flyEl.source = this;

      // ✅ arrivo icona carrello del tema
      flyEl.destination = cartIcon;

      document.body.appendChild(flyEl);
    }

    /* =========================
       SHOW/HIDE BASED ON ATC VISIBILITY
       ========================= */
    setupAtcObserver() {
      const target = document.querySelector('add-to-cart-component');

      if (!target) {
        this.classList.add('satc--hidden', 'is-ready');
        return;
      }

      const updateSticky = () => {
        const rect = target.getBoundingClientRect();

        // Mostra lo sticky SOLO quando abbiamo scrollato
        // completamente oltre il bottone originale.
        if (rect.bottom <= 0) {
          this.classList.remove('satc--hidden');
        } else {
          this.classList.add('satc--hidden');
        }
      };

      // Stato iniziale
      updateSticky();

      requestAnimationFrame(() => {
        this.classList.add('is-ready');
      });

      // Aggiorna durante lo scroll
      window.addEventListener('scroll', updateSticky, { passive: true });

      // Utile se cambia il layout / orientamento
      window.addEventListener('resize', updateSticky, { passive: true });

      this.updateSticky = updateSticky;
    }


    handleAtcVisibility(entries) {
      const entry = entries[0];
      if (!entry) return;

      if (entry.isIntersecting) {
        // quando il target è visibile → nascondi sticky (torna sopra)
        this.classList.add('satc--hidden');
        this.classList.remove('satc--showing');
      } else {
        // quando serve mostrarlo → entra dall’alto fino al bottom
        this.classList.remove('satc--hidden');
        this.classList.add('satc--showing');

        // pulizia classe animazione
        this.addEventListener('animationend', () => {
          this.classList.remove('satc--showing');
        }, { once: true });
      }
    }


    isElementInViewport(el) {
      const r = el.getBoundingClientRect();
      return r.bottom > 0 && r.right > 0 && r.left < window.innerWidth && r.top < window.innerHeight;
    }

    disconnectedCallback() {
      if (this.atcObserver) this.atcObserver.disconnect();
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-button-vault"] && !Shopify.designMode) return;
  try {
    (function () {
  class StickyVault extends HTMLElement {
    constructor() {
      super();
      this.atcObserver = null;
    }

    connectedCallback() {
      // parte hidden
      this.classList.add('sv--hidden');

      // aspetta che il DOM sia pronto
      requestAnimationFrame(() => this.setupObserver());
    }

    setupObserver() {
      // ✅ trigger = il banner vero in pagina (section)
      // importante: prendiamo un elemento che NON sia questo sticky
      const banner = document.querySelector('section#vault-banner');

      if (!banner) {
        // se non esiste, mostralo sempre
        this.classList.remove('sv--hidden');
        return;
      }

      const showSticky = () => {
        if (!this.classList.contains('sv--hidden')) return;

        this.classList.remove('sv--hidden', 'sv--hiding');
        this.classList.add('sv--showing');

        this.addEventListener(
          'animationend',
          () => this.classList.remove('sv--showing'),
          { once: true }
        );
      };

      const hideSticky = () => {
        if (this.classList.contains('sv--hidden') || this.classList.contains('sv--hiding')) return;

        this.classList.remove('sv--showing');
        this.classList.add('sv--hiding');

        this.addEventListener(
          'animationend',
          () => {
            this.classList.remove('sv--hiding');
            this.classList.add('sv--hidden');
          },
          { once: true }
        );
      };

      this.atcObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;

          if (entry.isIntersecting) hideSticky();
          else showSticky();
        },
        {
          root: null,
          threshold: 0,
          rootMargin: "-120px 0px 0px 0px"
        }
      );

      this.atcObserver.observe(banner);
    }

    disconnectedCallback() {
      if (this.atcObserver) this.atcObserver.disconnect();
    }
  }

  if (!customElements.get('sticky-vault')) {
    customElements.define('sticky-vault', StickyVault);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
